"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var createBistate_1 = require("../createBistate");

var useBistate_1 = __importDefault(require("./useBistate"));

var currentProps = null;

function view(factory) {
  var Component = function Component(props) {
    try {
      currentProps = props;
      return factory(props);
    } finally {
      currentProps = null;
    }
  };

  return Component;
}

exports.default = view;

exports.useAttrs = function (initValue) {
  if (!currentProps) {
    throw new Error("you may forgot to wrap function-component by view(f)");
  }

  var state = useBistate_1.default(initValue);
  return mergeBistate(state, currentProps);
};

exports.useAttr = function (name, initValue) {
  var _a;

  var state = exports.useAttrs((_a = {}, _a[name] = initValue, _a));
  return state[name];
};

var mergeBistate = function mergeBistate(target, source) {
  var result = {};

  for (var key in target) {
    var value = target[key];
    result[key] = value;
    if (!createBistate_1.isBistate(value)) continue;
    var sourceValue = source[key];
    if (!createBistate_1.isBistate(sourceValue)) continue;
    result[key] = sourceValue;
  }

  return result;
};